@if (disableAgreement()) {
  <div class="warnings margin-top-1">
    <p class="warning icon-close">
      {{ 'my-contracts.quote-soldTo-message' | translate }}
      <app-tooltip
        link="{{ 'my-contracts.add-quote-modal-why-tooltip-link' | translate }}"
        text="{{ 'my-contracts.add-quote-modal-why-tooltip-text' | translate }}">
      </app-tooltip>
    </p>
  </div>
}
<ng-container>
  <ng-container>
    @if (agreement) {
      <div class="contract-details">
        <div class="details" [ngClass]="{'disabled': disableAgreement()}">
          <div class="details__info">
            <div class="details__list">
              @for (attribute of attributes; track attribute) {
                <div
                  class="details__list-item {{attribute.attribute}}"
                  [ngClass]="attribute.attribute === 'contractNumber' && needsAttention ? 'hidden' : ''">
                  <div class="details__list-item--title">
                    {{ attribute.label | translate }}
                    @if (attribute.tooltip) {
                      <app-tooltip
                        link="icon"
                        text="{{ attribute.tooltip | translate }}">
                      </app-tooltip>
                    }
                  </div>
                  <div class="details__list-item--data">
                    {{ getAttribute(attribute.attribute, attribute.nestedAttribute ?? '') }}
                  </div>
                </div>
              }
            </div>
            <div class="details__messages">
              <div class="warnings">
                @if (
                  hasSupportDateUnder60Days
                  && hasContractEndDateUnder60DaysOrIsNull
                  && !supportAndContractEndsSameDay
                  && !inactive) {
                  <p class="warning icon-warning">
                    {{ 'my-contracts.warning-term' | translate }}
                  </p>
                }
                @if (inactive && !isEquipment) {
                  <p class="warning icon-warning">{{ 'my-contracts.quote-submitted' | translate }}</p>
                }
              </div>
            </div>
          </div>
          <app-access-control [notForViewer]="true">
            <ng-container ngProjectAs="[slot][nonViewerContent]">
              @if (disableAgreement()) {
                <div class="details__buttons">
                  <span class="new-quote-desc">{{ 'my-contracts.start-new-quote' | translate }}</span>
                </div>
              } @else {
                <div class="details__buttons">
                  @if (needsAttention && !isEquipment) {
                    <button
                      type="button"
                      class="button button--primary action-button" [attr.data-test]="'button-startConfiguration'"
                      [disabled]="inactive || addItemOperationInProgress"
                      (click)="startConfiguration()">
                      <span>{{ 'my-contracts.start-configuration' | translate }}</span>
                    </button>
                  }
                  @if (isEquipment && selectableEquipment) {
                    <span class="equipment-buttons">
                      @if (!equipmentSelectionInProgress) {
                        <button
                          type="button"
                          class="button button--primary action-button"
                          [attr.data-test]="'button-selectEquipment'"
                          [disabled]="isCartOperationInProgress || loadingCartDataInProgress || addItemOperationInProgress"
                          (click)="startEquipmentSelection()">
                          <span>{{ 'my-equipment.select-equipment' | translate }}</span>
                        </button>
                      } @else {
                        <div class="spinner">
                          <div class="loading-animation"></div>
                        </div>
                      }
                      <div class="additional-options">
                        @if (isUserSparePartsViewer()) {
                          <a class="spare-parts-viewer"
                            (click)="openSparePartsViewer()"
                            [attr.data-test]="'link-sparePartsViewer'">
                            <span class="icon-arrow-long-right"></span>
                            <span>{{ 'my-equipment.select-spare-parts-viewer' | translate }}</span>
                          </a>
                        }
                        <br>
                          <a href="{{ getTeamplayFleetContractUrl() }}" [attr.data-test]="'link-selectTeamPlayFleet'"
                            target="_blank"
                            rel="noopener">
                            <span class="icon-arrow-long-right"></span>
                            <span>{{ 'my-equipment.select-teamplay-fleet' | translate }}</span>
                          </a>
                        </div>
                      </span>
                    }
                    @if (!soldToInactive && soldToIdFromParams) {
                      <p class="sold-to-active-info">
                      {{ 'my-contracts.configuration-added-to-existing-quote' | translate }}</p>
                    }
                    @if (!needsAttention && !selectableEquipment) {
                      <a class="button button--primary action-button" [attr.data-test]="'link-viewContractDetails'"
                        href="{{ getTeamplayFleetContractUrl() }}"
                        target="_blank"
                        rel="noopener">
                        <span>{{ 'my-contracts.contract-details' | translate }}</span>
                      </a>
                      <p class="details-desc">{{ 'my-contracts.contract-details-desc' | translate }}</p>
                    }
                  </div>
                }
              </ng-container>
            </app-access-control>
          </div>
          <app-my-equipment-components
            [agreement]="agreement">
          </app-my-equipment-components>
          @if (!isEquipmentCompatible) {
            <div class="equipment-warning">
              <span class="icon-warning icon-warning__circle"></span>
              <span class="equipment-warning__message">
                {{ 'my-equipment.warning-message' | translate }}
              </span>
            </div>
          }
          @if (isAddQuoteModalOpen) {
            <app-modal
              [id]="'add-quote-modal'"
              [open]="isAddQuoteModalOpen"
              [title]="'my-contracts.add-quote-modal-title' | translate"
              (crossClick)="isAddQuoteModalOpen = false"
              (outsideClick)="isAddQuoteModalOpen = false">
              <ng-container ngProjectAs="[slot][body]">
                <app-add-quote-modal
                  [flNumber]="agreement.attributes?.siemensEquipmentId"
                  [materialNumber]="agreement.attributes?.materialNumber"
                  [soldToIdFromParams]="soldToIdFromParams"
                  [modalitiesAndMaterialNumbers]="modalitiesAndMaterialNumbers"
                  [productSku]="productSku">
                </app-add-quote-modal>
              </ng-container>
            </app-modal>
          }
        </div>
      }
    </ng-container>
  </ng-container>
  <app-modal-confirm
    class="modal-confirm"
    [type]="iconType.WARNING"
    modalTitle="{{ 'equipment-selection.you-have-items-in-cart' | translate }}"
    notifyText="{{ getChangeEquipmentModalText() | translate }}"
    secondaryBtnText="{{ 'equipment-selection.new-cart' | translate }}"
    primaryBtnText="{{ 'equipment-selection.change-equipment' | translate }}"
    [showModalConfirm]="showModalChangeEquipmentOrCreateNewCart"
    (closeModalConfirm)="closeModalChangeEquipmentOrCreateNewCart()"
    (secondaryActionConfirm)="createNewCartForEquipment()"
    (primaryActionConfirm)="changeEquipmentForCurrentCart()">
  </app-modal-confirm>
